// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';

export const FolderClosed = createSvgIcon(
  { LeftToRight: <React.Fragment><path stroke="currentColor" strokeWidth="2" d="M1.11 6.0995C1.051 5.5108 1.5134 5 2.105 5h11.8063c.5924 0 1.0549.512.9949 1.1013l-.8147 8a1 1 0 01-.9948.8987H2.905a1 1 0 01-.995-.9005l-.8-8z" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 4.976V2.5C3 1.6716 3.657 1 4.4673 1h2.2119C8.132 1 8.132 2.0118 8.869 2h3.1318C12.5531 2 13 2.4477 13 3v2" /></React.Fragment>, },
  'small'
);
